import * as Services from "../../Service/Service"

export const GetFileInJsonString = (
  UserID,
  fileApprovedStatus,
  Startdate,
  Enddate
) => {
  const params = { UserID, fileApprovedStatus, Startdate, Enddate };

  let res = Services.GETSERVICE(
    `/api/FileReadWrite/GetFileInJsonString`,
    params,
    {}
  );
  return res;
};

export const UpdateFileAsApproved = (fileId, status) => {
  let token = localStorage.getItem("token");

  let res = Services.POST(
    `api/FileReadWrite/UpdateFileAsApproved?FileApprovedID=${fileId}&ApprovedStatus=${status}`,
    "",
    token
  );
  return res;
};

export const UpdateFileInJsonString = (payload) => {
  let token = localStorage.getItem("token");

  let res = Services.POST(
    `/api/FileReadWrite/UpdateFileInJsonString`,
    payload,
    token
  );
  return res;
};

export const DownloadFile = (FileID) => {
  const token = localStorage.getItem("token");
  const params = { FileID };
  const responseType = "blob";

  let res = Services.GETSERVICE(
    `/api/FileReadWrite/DownloadFile`,
    {params},
    {responseType}
  );
  return res;
};
